import { render, staticRenderFns } from "./SuratBpkb.vue?vue&type=template&id=f7d1d46e&"
import script from "./SuratBpkb.vue?vue&type=script&lang=js&"
export * from "./SuratBpkb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports